// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__ws8HV","text":"style_text__dfs+X"};